// extracted by mini-css-extract-plugin
export default {"search":"PositionsWidget_search__ijLow","productCol":"PositionsWidget_productCol__yIoh-"};